import * as React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
const CalendarTodayIcon = ({ customColor, ...props }) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_8103_16393)">
            <Path d="M13.332 1.99935H12.6654V0.666016H11.332V1.99935H4.66536V0.666016H3.33203V1.99935H2.66536C1.93203 1.99935 1.33203 2.59935 1.33203 3.33268V13.9993C1.33203 14.7327 1.93203 15.3327 2.66536 15.3327H13.332C14.0654 15.3327 14.6654 14.7327 14.6654 13.9993V3.33268C14.6654 2.59935 14.0654 1.99935 13.332 1.99935ZM13.332 13.9993H2.66536V5.33268H13.332V13.9993Z" fill={customColor ?? "#521FAC"} />
        </G>
        <Defs>
            <ClipPath id="clip0_8103_16393">
                <Rect width="16" height="16" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>

);
export default CalendarTodayIcon;
